"use client"

import { useState, useEffect } from "react"
import { Box, Typography, Paper, CircularProgress, Breadcrumbs, Link as MuiLink, Button } from "@mui/material"
import { Link } from "react-router-dom"
import DashboardLayout from "../components/DashboardLayout"
import axios from "axios"
import { API_URL } from "../constants"
import ReactMarkdown from "react-markdown"
import { useSelector } from "react-redux"
import { Edit as EditIcon } from "@mui/icons-material"

const TermsPage = () => {
  const { userInfo } = useSelector((state) => state.auth)
  const [terms, setTerms] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchTerms = async () => {
      try {
        const { data } = await axios.get(`${API_URL}/api/terms`)
        setTerms(data)
      } catch (err) {
        setError(err.response?.data?.message || "Failed to load terms and conditions")
      } finally {
        setLoading(false)
      }
    }

    fetchTerms()
  }, [])

  return (
    <DashboardLayout>
      <Box sx={{ maxWidth: 1000, mx: "auto" }}>
        <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
          <MuiLink component={Link} to="/dashboard" color="inherit" underline="hover">
            Dashboard
          </MuiLink>
          <Typography color="text.primary">Terms & Conditions</Typography>
        </Breadcrumbs>

        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
          <Typography variant="h4" component="h1">
            Terms & Conditions
          </Typography>
          {userInfo?.user?.role === "admin" && (
            <Button component={Link} to="/admin-terms" variant="contained" color="primary" startIcon={<EditIcon />}>
              Manage Terms
            </Button>
          )}
        </Box>

        <Paper sx={{ p: 4, mt: 3 }}>
          {loading ? (
            <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
              <CircularProgress />
            </Box>
          ) : error ? (
            <Typography color="error">{error}</Typography>
          ) : (
            <Box>
              <Box sx={{ mb: 3 }}>
                <Typography variant="body2" color="text.secondary">
                  Last updated: {new Date(terms.lastUpdated).toLocaleDateString()} at{" "}
                  {new Date(terms.lastUpdated).toLocaleTimeString()}
                </Typography>
              </Box>
              <Box
                sx={{
                  "& h1": { fontSize: "2rem", mb: 3, mt: 2, color: "#2e3b55", fontWeight: "bold" },
                  "& h2": { fontSize: "1.5rem", mb: 2, mt: 3, color: "#2e3b55", fontWeight: "bold" },
                  "& h3": { fontSize: "1.3rem", mb: 1.5, mt: 2.5 },
                  "& p": { mb: 2 },
                  "& ul, & ol": { mb: 2, pl: 4 },
                  "& li": { mb: 1, lineHeight: 1.6 },
                  "& ol": { counterReset: "item" },
                  "& ol > li": {
                    display: "block",
                    position: "relative",
                    paddingLeft: "1.5em",
                    marginBottom: "0.5em",
                  },
                  "& ol > li::before": {
                    content: "counter(item) '.'",
                    counterIncrement: "item",
                    position: "absolute",
                    left: 0,
                    fontWeight: "bold",
                  },
                  "& blockquote": {
                    borderLeft: "4px solid #ccc",
                    paddingLeft: "1em",
                    fontStyle: "italic",
                    color: "#555",
                  },
                }}
              >
                <ReactMarkdown>{terms.content}</ReactMarkdown>
              </Box>
            </Box>
          )}
        </Paper>
      </Box>
    </DashboardLayout>
  )
}

export default TermsPage

